module.exports = __webpack_public_path__ + "img/43.f14fc4a3.webp";